export const DATA_PRIVATE_ATTRIBUTE = 'data-private';
export const UNNAMED_ELEMENT_VALUE = '<unnamed>';
export const REDACTED_PRIVATE_DATA_VALUE = '<redacted_pii_data>';
export const MAX_INNER_TEXT_LENGTH = 250;
export const MIN_INNER_TEXT_LENGTH = 5;
